<atx-videojs-media-player
  [src]="media.url"
  [timelineMarkers]="videoMarkers"
  [playVideo]="(isConfigStripOpen$ | async) === false"
  [defaultTimeStamp]="defaultVideoDuration"
  [defaultVolume]="defaultVideoVolumne"
  (timeUpdate)="onTimeUpdate($event)"
  (volumeChange)="onVolumeUpdate($event)"
  (loadedMetadata)="onLoadedMetadata($event)"
  (fullscreenClicked)="onFullScreenClicked()"
  [enableFullScreen]="enableFullScreen"
>
</atx-videojs-media-player>

<epc-epic-show-product-presentation
  [products]="activeProducts$$ | async"
></epc-epic-show-product-presentation>
